export default __webpack_public_path__ + "static/media/memoryRetention.c6bd1946.jpg";